import React, { useEffect, useState } from "react";
import Header from "../../../../Components/Dashboard/Header/Header";
import Sidebar from "../../../../Components/Dashboard/Sidebar/Sidebar";
import { BiHomeAlt } from "react-icons/bi";
import { MdKeyboardArrowRight } from "react-icons/md";
import "../RecasSceenshots/RecasSceenshots.css";
import Loader from "../../../../Components/loader/loader";
import { useLocation } from "react-router-dom";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { RxCross2 } from "react-icons/rx";
import { Apiurl, GetToken } from "../../../../Utils/utils";
import axios from "axios";
import { toast } from "react-toastify";
import moment from "moment";

const RecasSceenshots = () => {
  const LoginToken = GetToken();
  // const navigate = useNavigate();

  const location = useLocation();
  const screenCaptureData = location?.state?.data;
  const [zoomLevel, setZoomLevel] = useState(1);
  const [showImageModal, setShowImageModal] = useState(false);
  const [allImages, setAllImages] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [imagesPerPage, setImagesPerPage] = useState(10);
  const [allPagesNumber, setAllPagesNumber] = useState([]);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [start, setStart] = useState({ x: 0, y: 0 });
  const [totalCount, setTotalCount] = useState(0);
  const [imageId, setImageId] = useState([]);
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  useEffect(() => {
    if (allImages?.length > 0) {
      setImageId(allImages[0]?.ImageIds || []);
      setTotalCount(allImages?.length || 0);
    }
  }, [allImages]);


  const indexOfLastImage = currentPage * imagesPerPage;
  const indexOfFirstImage = indexOfLastImage - imagesPerPage;
  const currentImages = allImages.slice(indexOfFirstImage, indexOfLastImage);

  const handleImageClick = (index) => {
    setSelectedImageIndex(index);
    setShowImageModal(true);
  };

  const [showSidebar, setShowSidebar] = useState(true);
  const [loading, setLoading] = useState(false);
  const [selectImageId, setSelectImageId] = useState();
  // const [imageId, setImageId] = useState();

  useEffect(() => {
    if (window.innerWidth < 600) {
      const timeoutId = setTimeout(() => {
        setShowSidebar(false);
      }, 1000);
      return () => clearTimeout(timeoutId);
    }
    setShowSidebar(true);
  }, []);
  // useEffect(()=>{
  //   const pages=Math.ceil(totalCount/10);//7
  //   const arrNumber = Array.from({ length: pages }, (_, i) => i + 1);
  //   setAllPagesNumber(arrNumber)
  // },[totalCount])
  const [selectedId, setSelectedId] = useState('')
  const [displayRange, setDisplayRange] = useState({ start: 1, end: 3 });

  // Function to get pagination pages to display
  const getPaginationPages = () => {
    const totalPages = allPagesNumber?.length || 0;
    const pagesToShow = 3;
    const pages = [];

    // Add pages in range
    for (let i = displayRange.start; i <= Math.min(displayRange.end, totalPages); i++) {
      pages.push(i);
    }

    // Add ellipsis and last page if needed
    if (displayRange.end < totalPages - 1) {
      pages.push('...');
      pages.push(totalPages);
    } else if (displayRange.end === totalPages - 1) {
      pages.push(totalPages);
    }

    return pages;
  };

  // Handle next page arrow
  const handleNextPages = () => {
    const totalPages = allPagesNumber?.length || 0;
    if (displayRange.end < totalPages) {
      setDisplayRange({
        start: displayRange.start + 1,
        end: displayRange.end + 1
      });
    }
  };

  // Handle previous page arrow
  const handlePrevPages = () => {
    if (displayRange.start > 1) {
      setDisplayRange({
        start: displayRange.start - 1,
        end: displayRange.end - 1
      });
    }
  };

  const handleSubmitScreenShot = (e, index) => {
    const data = {};
    if (e === "NumberClick") {
      const startIndex = index * 10;
      const endIndex = startIndex + 10;
      const selectedIds = selectImageId.slice(startIndex, endIndex);
      setSelectedId(selectedIds)
      data.pageNumber = 1;
      data.ImageIds = selectedIds;
    } else {
      setSelectImageId(e?.ImageIds);
      const arrayNum = e?.ImageIds;
      const pageValue = e?.ImageIds.length / 10;
      const maxNumber = Math.ceil(pageValue);
      const numbers = [];
      for (let i = 1; i <= maxNumber; i++) {
        numbers.push(i);
      }
      setAllPagesNumber(numbers);
      setDisplayRange({ start: 1, end: 3 });
      const pageNumber = 10;
      const result = arrayNum?.slice(0, pageNumber);
      data.pageNumber = 1;
      data.ImageIds = result;
    }
    setLoading(true);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },

      url: `${Apiurl()}/Recas/GetImages`,
      data: { data: JSON.stringify(data) },
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        const responceData = e?.data?.data;
        const verifyData = JSON.parse(responceData);
        setAllImages(verifyData);
        if (e?.status === 200) {
          toast.success(e?.data?.message);
          // navigate("/Adm/RecasScreenshot", { state: { data: verifyData } });
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  };
  // const paginate = (pageNumber) => {
  //   setCurrentPage(pageNumber);
  //   // handleSubmitScreenShot()
  // };

  const handleNextImage = () => {
    if (selectedImageIndex < allImages.length - 1) {
      setSelectedImageIndex(selectedImageIndex + 1);
      setZoomLevel(1);
    }
  };

  const handlePrevImage = () => {
    if (selectedImageIndex > 0) {
      setSelectedImageIndex(selectedImageIndex - 1);
      setZoomLevel(1);
    }
  };

  const handleZoomChange = (e) => {
    const newZoom = parseFloat(e.target.value);
    setZoomLevel(newZoom);
    if (newZoom === 1) {
      setPosition({ x: 0, y: 0 });
    }
  };

  const handleMouseDown = (e) => {
    if (zoomLevel === 1) return;
    setIsDragging(true);
    setStart({
      x: e.clientX - position.x,
      y: e.clientY - position.y
    });
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;

    setPosition({
      x: e.clientX - start.x,
      y: e.clientY - start.y
    });
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  return (
    <>
      {loading ? <Loader /> : null}
      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
      <div className="d-flex">
        <Sidebar showSidebar={showSidebar} />
        <>
          <section
            className={
              showSidebar
                ? "dashboard-main-container"
                : "dashboard-main-container-new"
            }
          >
            <div className="all-icons">
              <div>
                <p className="DASHBOARD-MAIN-HEADING">Recas </p>
              </div>
              <div className="dashboiard-inner-header">
                <BiHomeAlt className="home-icon-header-inn" />
                <MdKeyboardArrowRight />
                <p>Recas </p>
                <MdKeyboardArrowRight />
                <p>Screenshot </p>
              </div>
            </div>
            <div>
              <div className="emp-dashboard-Leave-Requests-main-container">
                <div className="emp-dashboard-Leave-outter">
                  <div className="emp-dashboard-card-header">
                    <div>
                      <p className="Leave-heading">Recas</p>
                    </div>
                  </div>
                  <div className="table-for-tasks-overflow-data">
                    <table className="table-of-employee-leaves">
                      <thead className="thead-of-emp-table-leaves">
                        <tr className="">
                          <th className="hr-dashboard-no">Sr. No.</th>
                          <th className="hr-dashboard-Action">Task</th>
                          <th className="hr-dashboard-Action">Start Time</th>
                          <th className="hr-dashboard-Action">End Time</th>
                          <th className="hr-dashboard-Action">Action</th>
                        </tr>
                      </thead>

                      {screenCaptureData && screenCaptureData?.length > 0 ? (
                        <tbody className="tbody-ofemp-table-leaves">
                          {screenCaptureData
                            ?.sort((a, b) =>
                              a.Task?.Description.localeCompare(
                                b.Task?.Description
                              )
                            )
                            ?.map((item, index) => (
                              <tr key={index}>
                                <td> {index + 1}</td>
                                <OverlayTrigger
                                  placement="left"
                                  overlay={
                                    <Tooltip id="tooltip">
                                      {item?.Task?.Description}
                                    </Tooltip>
                                  }
                                >
                                  <td>
                                    {item?.Task?.Description?.length > 22
                                      ? `${item?.Task?.Description.slice(
                                        0,
                                        22
                                      )}..`
                                      : item?.Task?.Description}
                                  </td>
                                </OverlayTrigger>
                                <td>
                                  {/* {new Date(item?.StartTime).toLocaleDateString(
                                "en-US",
                                {
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "numeric",
                                }
                              )}
                              {new Date(item?.StartTime).toLocaleTimeString(
                                "en-US",
                                { hour: "2-digit", minute: "2-digit" }
                              )} */}

                                  {`${moment(item?.StartTime).format(
                                    "DD MMM YYYY"
                                  )} ${moment(item?.StartTime).format(
                                    "HH:mm"
                                  )}`}
                                </td>
                                <td>
                                  {/* {new Date(item?.EndTime).toLocaleDateString(
                                "en-US",
                                {
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "numeric",
                                } 
                              )}
                              {new Date(item?.EndTime).toLocaleTimeString(
                                "en-US",
                                { hour: "2-digit", minute: "2-digit" }
                              )} */}

                                  {`${moment(item?.EndTime).format(
                                    "DD MMM YYYY"
                                  )} ${moment(item?.EndTime).format("HH:mm")}`}
                                </td>
                                <td>
                                  <button
                                    className="screenshot-button"
                                    onClick={(e) => {
                                      setTotalCount(item?.ImageIdsCount);
                                      handleSubmitScreenShot(item);
                                    }}
                                  >
                                    Screenshots
                                  </button>
                                </td>
                                {/* <p>{item?.ImageIdsCount}</p> */}
                              </tr>
                            ))}
                        </tbody>
                      ) : (
                        // <div className="noDataFound">
                        <tbody>
                          <tr>
                            <td className="no-data-avilable-on-this-table" colSpan="5" >
                              No data available
                            </td>
                          </tr>
                        </tbody>
                        // </div>
                      )}
                    </table>
                  </div>
                </div>
              </div>

              <div className="dashboard-allcards-flex-container-recas">
                {allImages?.map((item, index) => (
                  <div
                    className="dashboard-card-first-one-recas"
                    onClick={() => handleImageClick(index)}
                    key={index}
                  >
                    <p className="recas-ScreenshotTime">
                      {moment(item?.ScreenshotTime).format("DD MMM YYYY HH:mm")}
                    </p>

                    <img src={item?.Base64Image || "/placeholder.svg"} alt="" />
                  </div>
                ))}
              </div>
              <div className="handelPage-Numbers">
                <button
                  className="pagination-arrow-btn pagination-prev-btn"
                  onClick={handlePrevPages}
                  disabled={displayRange.start === 1}
                  title="Previous pages"
                >
                  &lt;
                </button>

                {getPaginationPages()?.map((item, index) => {
                  if (item === '...') {
                    return (
                      <span key={index} className="pagination-ellipsis">
                        {item}
                      </span>
                    );
                  }
                  return (
                    <div
                      key={index}
                      className={selectedId === item ? "selectedIdscss" : "AllNumbers-design"}
                      onClick={() => handleSubmitScreenShot("NumberClick", item - 1)}
                    >
                      {item}
                    </div>
                  );
                })}

                <button
                  className="pagination-arrow-btn pagination-next-btn"
                  onClick={handleNextPages}
                  disabled={displayRange.end >= (allPagesNumber?.length || 0)}
                  title="Next pages"
                >
                  &gt;
                </button>
              </div>
            </div>
            <div className="emp-dashboard-cards"></div>
          </section>
        </>
      </div>
      {showImageModal && selectedImageIndex !== null && (
        <Modal
          show={showImageModal}
          onHide={() => {
            setShowImageModal(false);
            setZoomLevel(1);
            setPosition({ x: 0, y: 0 });
          }}
          size="xl"
          centered
          contentClassName="image-preview-modal-content"
        >
          <Modal.Body
            style={{
              position: "relative",
              height: "90vh",
              padding: 0,
              display: "flex",
              flexDirection: "column"
            }}
          >
            <div
              style={{
                position: "absolute",
                top: "-15px",
                right: "60px",
                zIndex: 10,
                cursor: "pointer",
                background: "rgba(0,0,0,0.5)",
                borderRadius: "50%",
                padding: "6px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <RxCross2
                size={22}
                color="white"
                onClick={() => {
                  setShowImageModal(false);
                  setZoomLevel(1);
                  setPosition({ x: 0, y: 0 });
                }}
              />
            </div>
            {/* Image */}
<div
  style={{
    flex: 1,
    overflow: "hidden",
    position: "relative",  
    cursor: zoomLevel > 1 ? (isDragging ? "grabbing" : "grab") : "default"
  }}
  onMouseDown={handleMouseDown}
  onMouseMove={handleMouseMove}
  onMouseUp={handleMouseUp}
  onMouseLeave={handleMouseUp}
>

  <img
    src={allImages[selectedImageIndex]?.Base64Image || "/placeholder.svg"}
    alt="Full Screen"
    style={{
      width: "100%",
      height: "100%",
      objectFit: "contain",
      transform: `translate(${position.x}px, ${position.y}px) scale(${zoomLevel})`,
      transition: isDragging ? "none" : "transform 0.2s ease"
    }}
    draggable={false}
  />
</div>

            {/* Controls Bar */}
<div
  style={{
    // background: "white",
    padding: "18px 30px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "40px",
    boxShadow: "0 -2px 10px rgba(0,0,0,0.08)"
  }}
>

  {/* Previous */}
  <button
    onClick={handlePrevImage}
    disabled={selectedImageIndex === 0}
    className="screenshot-button"
  >
    Previous
  </button>

  {/* Zoom Slider */}
  <div style={{ display: "flex", alignItems: "center", gap: "15px", width: "350px" }}>
    <input
      type="range"
      min="1"
      max="3"
      step="0.1"
      value={zoomLevel}
      onChange={handleZoomChange}
      style={{ width: "100%" }}
    />
    <span style={{
    background: "white",
    padding: "6px 14px",
    borderRadius: "6px",
    fontWeight: 600,
    fontSize: "14px",
    border: "1px solid #e0e0e0",
    boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
    minWidth: "65px",
    textAlign: "center"
  }}>
      {Math.round(zoomLevel * 100)}%
    </span>
  </div>

  {/* Next */}
  <button
    onClick={handleNextImage}
    disabled={selectedImageIndex === allImages.length - 1}
    className="screenshot-button"
  >
    Next
  </button>

</div>

          </Modal.Body>
        </Modal>
      )}
    </>
  );
};
export default RecasSceenshots;